import { render, staticRenderFns } from "./decorationComponents.vue?vue&type=template&id=5005d9ad&scoped=true&"
import script from "./decorationComponents.vue?vue&type=script&lang=js&"
export * from "./decorationComponents.vue?vue&type=script&lang=js&"
import style0 from "./decorationComponents.vue?vue&type=style&index=0&id=5005d9ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005d9ad",
  null
  
)

export default component.exports